import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

export function useIsLeadManagementLanding(server: ServerData | null) {
  const path = usePathname();

  return useMemo(() => {
    if (!server) return false;
    const currentUrl = server.baseUrl + path;
    return [
      'https://www.geberit.ch/landingpages-de/traumbad/',
      'https://www.geberit.ch/landingpages-de/traumbad-tools/',
      'https://www.geberit.ch/landingpages-de/traumbad-cashback/',
      'https://preview-gdds-test-migration-country.dev.platform.web.geberit.com/landingpages-de/traumbad/',
      'https://preview-gdds-test-migration-country.dev.platform.web.geberit.com/landingpages-de/traumbad-tools/',
      'https://preview-gdds-test-migration-country.dev.platform.web.geberit.com/landingpages-de/traumbad-cashback/',
    ].includes(currentUrl);
  }, [path, server]);
}
